import Layout from "@/components/Layout";
import SolutionsShowcase from "@/components/home/SolutionsShowcase";
import GamesShowcase from "@/components/home/GamesShowcase";
import StatsPartners from "@/components/home/StatsPartners";
import ContactCTA from "@/components/home/ContactCTA";

const openDemo = () => window.dispatchEvent(new CustomEvent("alphatech:open-demo"));

export default function Solutions() {
  return (
    <Layout>
      <section className="relative pt-16 pb-8">
        <div className="absolute inset-0 hero-glow opacity-60" aria-hidden />
        <div className="absolute inset-0 grid-bg opacity-30" aria-hidden />
        <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
          <div className="overline">Solutions</div>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter leading-[1.05] max-w-4xl" data-testid="solutions-title">
            White label, turnkey & <span className="text-gradient-blue">crypto ready</span>.
          </h1>
          <p className="mt-5 text-gray-400 max-w-2xl leading-relaxed">
            Fully-branded platforms with 10,000+ games, secure APIs, 250+ payment integrations and licensed jurisdictions supported.
          </p>
        </div>
      </section>
      <SolutionsShowcase onOpenDemo={openDemo} />
      <GamesShowcase />
      <StatsPartners />
      <ContactCTA onOpenDemo={openDemo} />
    </Layout>
  );
}
